export const getCookie = (name) => {
  console.log(`🍪 getCookie: Looking for cookie '${name}'`);
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  const result = parts.length === 2 ? parts.pop().split(';').shift() : undefined;
  console.log(`🍪 getCookie: Cookie '${name}' result:`, result ? 'Found' : 'Not found');
  return result;
};

export const clearCookie = (name, domain = '.worksana.com') => {
  console.log(`🧹 clearCookie: Clearing cookie '${name}' for domain '${domain}'`);
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
  console.log(`🧹 clearCookie: Cookie '${name}' cleared`);
};